/*eslint no-undef: 0*/

import { fetchFromApi } from '../../helpers/api';

export const CreateAccountActionTypes = {
  CREATE_ACCOUNT_REQUEST: 'CREATE_ACCOUNT/CREATE_REQUEST',
  CREATE_ACCOUNT_SUCCESS: 'CREATE_ACCOUNT/CREATE_SUCCESS',
  CREATE_ACCOUNT_FAILURE: 'CREATE_ACCOUNT/CREATE_FAILURE',
  COMPLETE_ACCOUNT: 'CREATE_ACCOUNT/COMPLETE_ACCOUNT',
  SHOW_CREATE_ACCOUNT_MODAL: 'CREATE_ACCOUNT/SHOW_MODAL'
};

export const showCreateAccountModal = show => ({
  type: CreateAccountActionTypes.SHOW_CREATE_ACCOUNT_MODAL,
  show
});

export const completeAccount = () => ({
  type: CreateAccountActionTypes.COMPLETE_ACCOUNT
});

export const createAccount = formData => {
  const body = formData;

  // Lowercase the email

  formData.email = formData.email.toLowerCase();
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');

  const init = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  };

  return {
    types: [
      CreateAccountActionTypes.CREATE_ACCOUNT_REQUEST,
      CreateAccountActionTypes.CREATE_ACCOUNT_SUCCESS,
      CreateAccountActionTypes.CREATE_ACCOUNT_FAILURE
    ],
    shouldCallApi: state => !state.auth.get('isAuthenticated'),
    callApi: dispatch => fetchFromApi('client-api/signup/', init, dispatch)
  };
};



/** WEBPACK FOOTER **
 ** ./src/state/create-account/actions.js
 **/